<div class="ml-round-bar">
  <div class="ml-round-scroll">
    @for (round of rounds; track round) {
      <button
        type="button"
        class="round-chip"
        [class.active]="round.name === roundSelected"
        (click)="selectRound(round)"
      >
        {{ round.title }}
      </button>
    }
  </div>
  @if (isAdmin || (isMe && mode !== "results")) {
    <div class="joker-budget-strip">
      <div class="jb-budget-row">
        <div class="jb-coins">
          @for (n of jokerSlots; track n) {
            <img
              src="/assets/imgs/joker-on.svg"
              class="jb-coin"
              [class.jb-spent]="n <= jokersUsed"
            />
          }
        </div>
        <div class="jb-copy">
          <span class="jb-label">Jokers de la ronda</span>
          <span class="jb-value">
            @if (jokersUsed < MAX_JOKERS) {
              {{ MAX_JOKERS - jokersUsed }} de {{ MAX_JOKERS }} disponibles
            } @else {
              Sin jokers disponibles
            }
          </span>
        </div>
      </div>
      <div
        class="jb-pending-strip"
        [class.jb-pending-strip--complete]="pendingRoundMatchesCount === 0"
      >
        <span class="jb-pending-kicker">Pendientes</span>
        <span
          class="jb-pending-value"
          [class.jb-pending--complete]="pendingRoundMatchesCount === 0"
        >
          {{ pendingRoundMatchesLabel }}
        </span>
      </div>
    </div>
  }
</div>

<div class="ml-content">
  @if (roundMatches && roundMatches.length > 0) {
    @for (match of roundMatches; track match; let i = $index) {
      @if (match.homeTeam && match.awayTeam) {
        <div
          class="match-card"
          [id]="'match-' + match._id"
          [class.failed]="hasResult(roundResults, i) && match.points === 0"
          [class.success]="hasResult(roundResults, i) && match.points > 0"
          [class.joker]="match.useJoker"
        >
          <!-- Meta row: date + badges -->
          <div class="match-meta">
            <span class="match-date-lbl">{{
              match.date | date: "EEE d MMM · HH:mm"
            }}</span>
            <div class="match-badges">
              @if (match.useJoker) {
                <img src="/assets/imgs/joker-on.svg" class="joker-badge" />
              }
              @if (
                hasResult(roundResults, i) &&
                match.points !== null &&
                match.points !== undefined
              ) {
                <button
                  type="button"
                  class="pts-badge"
                  [class.pts-badge--open]="match.showPointsBreakdown"
                  [class.pts-success]="match.points > 0"
                  [class.pts-fail]="match.points === 0"
                  [attr.aria-expanded]="match.showPointsBreakdown"
                  [attr.aria-controls]="'match-points-breakdown-' + match._id"
                  (click)="togglePointsBreakdown(match, roundResults[i])"
                >
                  <span class="pts-badge-copy">
                    @if (match.points > 0) {
                      +{{ match.points }} pts
                    } @else {
                      0 pts
                    }
                  </span>
                  <mat-icon
                    class="pts-badge-icon"
                    [class.rotated]="match.showPointsBreakdown"
                    >expand_more</mat-icon
                  >
                </button>
              }
            </div>
          </div>

          <!-- Scoreboard -->
          <div class="match-scoreboard">
            <div class="match-team">
              <img class="team-flag" src="{{ match.homeTeam.flag }}" />
              <span class="team-name">{{ match.homeTeam.name }}</span>
            </div>

            <div class="score-center">
              @if (isAdmin || isMe || hasRoundStarted(match)) {
                <input
                  #input
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  min="0"
                  step="1"
                  maxlength="1"
                  [(ngModel)]="match.homeGoals"
                  (input)="onScoreInput(match, 'homeGoals', $event)"
                  [disabled]="
                    !isAdmin &&
                    mode !== 'results' &&
                    match.roundIniTimestamp < currentTimestamp
                  "
                  class="score-input"
                  placeholder="–"
                />
                <span class="score-sep">:</span>
                <input
                  #input
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  min="0"
                  step="1"
                  maxlength="1"
                  [(ngModel)]="match.awayGoals"
                  (input)="onScoreInput(match, 'awayGoals', $event)"
                  [disabled]="
                    !isAdmin &&
                    mode !== 'results' &&
                    match.roundIniTimestamp < currentTimestamp
                  "
                  class="score-input"
                  placeholder="–"
                />
              } @else {
                <span class="score-locked">?</span>
                <span class="score-sep">:</span>
                <span class="score-locked">?</span>
              }
            </div>

            <div class="match-team match-team--away">
              <img class="team-flag" src="{{ match.awayTeam.flag }}" />
              <span class="team-name">{{ match.awayTeam.name }}</span>
            </div>
          </div>

          <!-- Penalties row (KO draw) -->
          @if (
            match.round !== "GROUP_STAGE" &&
            match.homeGoals !== null &&
            match.awayGoals !== null &&
            match.homeGoals === match.awayGoals
          ) {
            <div class="penalties-row">
              <span class="pen-label">¿Quién gana en penaltis?</span>
              <div class="pen-selector">
                <button
                  type="button"
                  class="pen-option"
                  [class.pen-option--selected]="match.homeTeam.checked"
                  (click)="penaltiesChange(match, 1)"
                >
                  <img class="pen-flag" src="{{ match.homeTeam.flag }}" />
                  <span class="pen-name">{{ match.homeTeam.name }}</span>
                </button>
                <span class="pen-vs">VS</span>
                <button
                  type="button"
                  class="pen-option"
                  [class.pen-option--selected]="match.awayTeam.checked"
                  (click)="penaltiesChange(match, 2)"
                >
                  <img class="pen-flag" src="{{ match.awayTeam.flag }}" />
                  <span class="pen-name">{{ match.awayTeam.name }}</span>
                </button>
              </div>
            </div>
          }

          <!-- Real result (poll mode) -->
          @if (
            roundResults &&
            mode === "poll" &&
            roundResults[i] &&
            hasRoundStarted(match)
          ) {
            <div class="real-result-row">
              <span class="real-result-label">Resultado:</span>
              <span class="real-result-score">{{
                getMatchScoreSummary(roundResults[i])
              }}</span>
            </div>
          }

          @if (match.showPointsBreakdown && match.pointsBreakdown) {
            <div
              class="points-breakdown"
              [id]="'match-points-breakdown-' + match._id"
            >
              <div class="pb-summary">
                <div class="pb-summary-row">
                  <span class="pb-summary-label">Tu pronostico</span>
                  <span class="pb-summary-value">{{
                    getMatchScoreSummary(match)
                  }}</span>
                </div>
                <div class="pb-summary-row">
                  <span class="pb-summary-label">Resultado real</span>
                  <span class="pb-summary-value">{{
                    getMatchScoreSummary(roundResults[i])
                  }}</span>
                </div>
              </div>

              <div class="pb-list">
                @for (item of match.pointsBreakdown.items; track item.label) {
                  <div class="pb-item" [class.pb-item--hit]="item.points > 0">
                    <span class="pb-item-label">{{ item.label }}</span>
                    <span class="pb-item-points">
                      @if (item.points > 0) {
                        +{{ item.points }} pts
                      } @else {
                        0 pts
                      }
                    </span>
                  </div>
                }
              </div>

              <div class="pb-total-row">
                <span class="pb-total-label">Total</span>
                <span class="pb-total-points">
                  @if (match.pointsBreakdown.total > 0) {
                    +{{ match.pointsBreakdown.total }} pts
                  } @else {
                    0 pts
                  }
                </span>
              </div>
            </div>
          }

          <!-- Inline joker button -->
          @if (isAdmin || (isMe && mode !== "results")) {
            <div
              class="joker-bar"
              [class.joker-bar--active]="match.useJoker"
              [class.joker-bar--locked]="
                !isJokerEditable(match) && !match.useJoker
              "
            >
              <button
                type="button"
                class="joker-btn"
                [class.joker-btn--active]="match.useJoker"
                [class.joker-btn--disabled]="!isJokerEditable(match)"
                [class.joker-btn--maxed]="
                  !match.useJoker &&
                  !isJokerEditable(match) &&
                  jokersUsed >= MAX_JOKERS
                "
                (click)="toggleJoker(match)"
              >
                <img
                  src="/assets/imgs/joker-on.svg"
                  class="joker-btn-icon"
                  [class.joker-btn-icon--off]="!match.useJoker"
                />
                <span class="joker-btn-text">
                  @if (match.useJoker) {
                    🃏 Joker activo — ×2 puntos
                  } @else if (!isJokerEditable(match)) {
                    🃏 Joker bloqueado (ronda iniciada)
                  } @else if (jokersUsed + jokerCost(match) > MAX_JOKERS) {
                    🃏 Sin jokers suficientes
                  } @else {
                    🃏 Usar joker en este partido
                  }
                </span>
                <span
                  class="joker-cost-badge"
                  [class.joker-cost-badge--active]="match.useJoker"
                >
                  @for (c of [].constructor(jokerCost(match)); track $index) {
                    🟣
                  }
                </span>
              </button>
            </div>
          }

          <!-- Stats collapsible -->
          @if (isAdmin || match.roundIniTimestamp < currentTimestamp) {
            <app-match-stats
              [match]="match"
              [expanded]="match.showOptions"
              (expandedChange)="match.showOptions = $event"
              (usersSelected)="showStatUsers($event)"
            ></app-match-stats>
          }
        </div>
      } @else {
        <div class="match-card match-card--pending">
          <div class="match-meta">
            <span class="match-date-lbl">{{
              match.date | date: "EEE d MMM · HH:mm"
            }}</span>
          </div>
          <div class="match-scoreboard match-scoreboard--pending">
            <div class="match-team">
              <div class="team-flag team-flag--placeholder"></div>
              <span class="team-name team-name--placeholder">Por definir</span>
            </div>
            <div class="score-center">
              <span class="score-locked">?</span>
              <span class="score-sep">:</span>
              <span class="score-locked">?</span>
            </div>
            <div class="match-team match-team--away">
              <div class="team-flag team-flag--placeholder"></div>
              <span class="team-name team-name--placeholder">Por definir</span>
            </div>
          </div>
        </div>
      }
    }
  }
  @if (!roundMatches || roundMatches.length === 0) {
    <div class="empty-placeholder">
      <div class="empty-icon">⚽</div>
      <p class="empty-title">Sin partidos en esta fase</p>
      <p class="empty-sub">
        Selecciona otra ronda para ver los partidos disponibles.
      </p>
    </div>
  }
</div>
